import { Avatar, AvatarGroup, Box, Stack, Text } from 'shell/components';
import theme from 'shell/themes';

const sizes = ['small', 'medium', 'large', 'x-large'];

const people = [
    {
        id: '1',
        first_name: 'Georgina',
        last_name: 'Watson',
        display_name: 'George',
    },
];

const getColors = ({ palette }) => [
    { bgColor: palette.ensightful.error[800], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.error[600], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.error[100], textColor: palette.ensightful.error[900] },

    { bgColor: palette.ensightful.success[700], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.success[400], textColor: palette.ensightful.success[900] },
    { bgColor: palette.ensightful.success[100], textColor: palette.ensightful.success[900] },

    { bgColor: palette.ensightful.warning[600], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.warning[500], textColor: palette.ensightful.neutral[900] },
    { bgColor: palette.ensightful.warning[100], textColor: palette.ensightful.warning[900] },

    { bgColor: palette.ensightful.secondary[800], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.secondary[400], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.secondary[100], textColor: palette.ensightful.secondary[900] },

    { bgColor: palette.ensightful.primary[800], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.primary[500], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.primary[100], textColor: palette.ensightful.primary[900] },

    { bgColor: palette.ensightful.neutral[800], textColor: palette.ensightful.shades[0] },
    { bgColor: palette.ensightful.neutral[500], textColor: palette.ensightful.neutral[900] },
    { bgColor: palette.ensightful.neutral[200], textColor: palette.ensightful.neutral[900] },
];

const AvatarDemo = () => {
    const me = {
        first_name: 'Mingyu',
        last_name: 'Gao',
        display_name: '',
        profile_image: {
            bucket: 'ensightful-us-upload-app-develop-2',
            key: '85223ddf-cbe0-47a0-8091-ea7a8e64615a',
            name: 'orange.png',
            type: 'image/png',
        },
    };

    return (
        <>
            <Text variant={'sh1'}>Avatar</Text>

            <Box sx={{ my: 4 }}>
                <Stack sx={{ flexWrap: 'wrap', alignItems: 'flex-end' }} direction={'row'} spacing={2}>
                    {sizes.map((size) => (
                        <Avatar key={size} size={size} user={me} />
                    ))}
                </Stack>
            </Box>

            {sizes.map((size) => (
                <Box key={size} sx={{ my: 4 }}>
                    {people.map((person) => (
                        <Stack key={person.id} sx={{ flexWrap: 'wrap' }} direction={'row'} spacing={2}>
                            {getColors(theme).map(({ bgColor, textColor }, index) => (
                                <Avatar
                                    key={index}
                                    size={size}
                                    user={{ ...person, profile_circle: { bg_color: bgColor, text_color: textColor } }}
                                />
                            ))}
                        </Stack>
                    ))}
                </Box>
            ))}

            <AvatarGroup max={3} size={'small'} onClick={console.log}>
                <Avatar size={'small'} user={me} />
                <Avatar size={'small'} user={me} />
                <Avatar size={'small'} user={me} />
                <Avatar size={'small'} user={me} />
            </AvatarGroup>

            <AvatarGroup max={3} size={'medium'}>
                <Avatar size={'medium'} user={me} />
                <Avatar size={'medium'} user={me} />
                <Avatar size={'medium'} user={me} />
                <Avatar size={'medium'} user={me} />
            </AvatarGroup>

            <AvatarGroup max={3} size={'large'}>
                <Avatar size={'large'} user={me} />
                <Avatar size={'large'} user={me} />
                <Avatar size={'large'} user={me} />
                <Avatar size={'large'} user={me} />
            </AvatarGroup>

            <AvatarGroup max={3} size={'x-large'}>
                <Avatar size={'x-large'} user={me} />
                <Avatar size={'x-large'} user={me} />
                <Avatar size={'x-large'} user={me} />
                <Avatar size={'x-large'} user={me} />
            </AvatarGroup>
        </>
    );
};

export default AvatarDemo;
